export default __webpack_public_path__ + "static/media/screen2.63b850df.png";